import { render, staticRenderFns } from "./AdManagerBanners.vue?vue&type=template&id=3c1ca03c"
import script from "./AdManagerBanners.js?vue&type=script&lang=js&external"
export * from "./AdManagerBanners.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports